import { FileTextOutlined, FileImageOutlined } from "@ant-design/icons";
import { FaRegFilePdf } from "react-icons/fa";
import { Checkbox, Image, Tooltip } from 'antd';
import moment from "moment";
import ReSureSign from "../../Assets/Icons/Resure_icon.png";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import { useMediaQuery } from "react-responsive";

const OtherDocsTable = ({ reSureSignDocs, origin, handleCheckboxChange, checkedDocs }) => {

    const isSmallScreen = useMediaQuery({ maxWidth: 550 });
    const isMediumScreen = useMediaQuery({ maxWidth: 1000, minWidth: 551 });

    const thStyle = {
        textAlign: "center",
        padding: isSmallScreen ? 5 : "10px",
        fontSize: isSmallScreen ? 10 : "15px",
    };

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "800px",
                padding: isSmallScreen ? 0 : "0 20px",
                overflow: "auto",
                borderRadius: "8px",
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: isSmallScreen ? 10 : "15px",
                }}
            >
                <thead>
                    <tr
                        style={{
                            borderBottom: "1px solid #ccc",
                            backgroundColor: "hsl(211deg 75% 48%)",
                            color: "white",
                        }}
                    >
                        <th style={thStyle}>File Name</th>
                        <th style={thStyle}>Creation Date</th>
                        <th style={thStyle}>{origin === "TOOLS" ? "Options" : "Select"}</th>
                    </tr>
                </thead>
                <tbody>
                    {((reSureSignDocs?.length > 0 && origin === "PROPERTY_DOCS_RE_SURE_SIGN") ? reSureSignDocs : [])?.map((item, index) => (
                        <tr
                            key={index}
                            style={{
                                borderBottom: "1px solid #eee",
                                backgroundColor: index % 2 === 0 ? "#fafafa" : "white", // subtle striping
                            }}
                        >
                            <td
                                style={{
                                    padding: isSmallScreen ? "5px 2px 5px 10px" : "10px 5px 10px 30px",
                                    verticalAlign: "middle",
                                    cursor: origin === "PROPERTY_DOCS_RE_SURE_SIGN" ? "default" : "pointer",
                                }}
                            // onClick={() => {
                            //     origin !== "PROPERTY_DOCS_RE_SURE_SIGN" && handleOpenDoc(item);
                            // }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: isSmallScreen ? 5 : "10px",
                                    }}
                                >
                                    {item?.fileType === "IMAGE" ? (
                                        <FileImageOutlined
                                            style={{
                                                color: "#ecd540",
                                                marginTop: "5px",
                                                marginRight: "5px",
                                                fontSize: isSmallScreen ? 12 : "18px",
                                            }}
                                        />
                                    ) : item?.fileType === "PDF" || item?.isPdf || item?.pdfLink ? (
                                        <FaRegFilePdf
                                            style={{
                                                color: "red",
                                                marginTop: "5px",
                                                marginRight: "5px",
                                                fontSize: isSmallScreen ? 14 : "18px",
                                            }}
                                        />
                                    ) : (
                                        <FileTextOutlined style={{ color: "#74b3ed", fontSize: isSmallScreen ? 14 : "18px" }} />
                                    )}
                                    <ContractTypeBadge contractType={item?.contractType} additionalStyle={{ fontSize: isSmallScreen ? 10 : "12px" }} />
                                    {origin === "PROPERTY_DOCS_RE_SURE_SIGN" ?
                                        <div>
                                            <Tooltip title="RE-Sure Sign Document">
                                                <Image style={{ objectFit: "contain", width: isSmallScreen ? 30 : "35px", verticalAlign: "middle" }}
                                                    src={ReSureSign}
                                                    preview={false}
                                                />
                                            </Tooltip>
                                        </div> : ""}
                                    <span
                                        style={{
                                            color: "blue",
                                            fontSize: isSmallScreen ? 14 : "16px",
                                            maxWidth: "270px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            display: "inline-block",
                                        }}
                                    >
                                        {item?.updatedName || item?.documentName || item?.fileName || item?.formName}
                                        {item?.updatedName && (
                                            <>
                                                <br />
                                                <span style={{ fontSize: isSmallScreen ? 12 : "14px" }}>
                                                    ({item?.documentName || item?.fileName})
                                                </span>
                                            </>
                                        )}
                                    </span>
                                </div>
                            </td>

                            <td style={{ textAlign: "center", padding: "10px" }}>
                                {origin === "TOOLS" ? item?.createdAt :
                                    origin === 'PROPERTY_DOCS_RE_SURE_SIGN' ? (
                                        <div>
                                            <div >{moment(item?.createdAt).format("MM/DD/YYYY")}</div>
                                            <div style={{ fontSize: isSmallScreen ? 10 : "13px", color: "#777" }}>{moment(item?.createdAt).format("hh:mm A")}</div>
                                        </div>
                                    ) :
                                        item?.createdDateMili ? (
                                            <div>
                                                <div>{moment(origin === "PROPERTY_DOCS" ? item?.createdDateMili : item?.createdAt).format("MM/DD/YYYY")}</div>
                                                <div style={{ fontSize: isSmallScreen ? 10 : "13px", color: "#777" }}>{moment(origin === "PROPERTY_DOCS" ? item?.createdDateMili : item?.createdAt).format("hh:mm A")}</div>
                                            </div>
                                        ) : (
                                            "--"
                                        )}
                            </td>
                            {<td>
                                <Checkbox
                                    checked={checkedDocs.some((i) => i._id === item._id)}
                                    onChange={(e) => handleCheckboxChange(e.target.checked, item)}
                                />
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default OtherDocsTable